module.exports = __webpack_public_path__ + "img/roles-empty-state-no-results.63cee56d.svg";